
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game_condition_promotion",
      function () {
        return require("private-next-pages/game_condition_promotion.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/game_condition_promotion"])
      });
    }
  